import { createFileRoute, redirect } from '@tanstack/react-router'
import SignIn from '@/views/login'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/auth/login')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user) {
      throw redirect({
        to: '/dashboard'
      })
    }
  },
  component: SignIn,
})
